import mediaFormatsJson from "../../shared/media-formats.json";

export const MEDIA_FORMATS = mediaFormatsJson.formats;
export const MEDIA_ACCEPT = MEDIA_FORMATS.flatMap((format) => format.extensions.map((extension) => `.${extension}`)).join(",");
export const MEDIA_FORMAT_NAMES = MEDIA_FORMATS.map((format) => format.name).join(", ");

const extensions = new Set(MEDIA_FORMATS.flatMap((format) => format.extensions));

export function isSupportedMediaFile(file: File): boolean {
  const extension = file.name.includes(".") ? file.name.split(".").at(-1)!.toLowerCase() : "";
  return extensions.has(extension);
}
